'use client';

import {
  FormFieldSlot,
  type FormFieldSlotBaseProps,
} from '../../internal/components/form/FormFieldSlot';
import { type Component, type ComponentProps } from '../../types/component';
import { tv } from '../../utils/tv';

const textFieldSlotClasses = {
  root: 'zds-text-field-slot',
} as const;

const textFieldSlotStyles = tv({
  base: textFieldSlotClasses.root,
});

type TextFieldSlotBaseProps = FormFieldSlotBaseProps;

type TextFieldSlotProps = ComponentProps<TextFieldSlotBaseProps, 'span'>;

type TextFieldSlotComponent = Component<TextFieldSlotBaseProps, 'span'>;

const TextFieldSlot: TextFieldSlotComponent = (props) => {
  const { className, ...rest } = props;
  return (
    <FormFieldSlot {...rest} className={textFieldSlotStyles({ className })} />
  );
};

TextFieldSlot.displayName = 'TextField.Slot';

export {
  TextFieldSlot,
  type TextFieldSlotProps,
  type TextFieldSlotBaseProps,
  textFieldSlotClasses,
};
